<template>
    <simple-select-input
        v-if="periods.length > 1"
        v-model="period"
        :options="periods"
        :placeholder="trans('order.select-period')"
        name="period"
        @input="periodSelected()"
    />
    <span v-else class="field--static">{{ periods[0].value }}</span>
</template>
<script>
export default {
    props: {
        prices: {
            type: Array,
            required: true
        },
        currentPeriod: {
            type: Number,
            default: null
        },
        registrationType: {
            type: String,
            default: 'registration',
            required: true
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            period: null
        };
    },
    computed: {
        /**
         * Get valid periods from the product prices.
         *
         * @return {array}
         */
        periods() {
            let periods = this.prices
                .filter(price => {
                    if (price.type == this.registrationType) {
                        return true;
                    }

                    return false;
                })
                .map(price => {
                    return {
                        key: price.period,
                        value: trans('order.periods.' + price.period)
                    };
                });

            return periods;
        }
    },
    /**
     * Set initial data as soon as the component is ready.
     */
    mounted() {
        if (this.currentPeriod) {
            this.period = this.currentPeriod;

            return;
        }

        this.period = this.getDefaultPeriod();
    },
    methods: {
        /**
         * Get the default period to display in the select.
         *
         * @return {number}
         */
        getDefaultPeriod() {
            let periods = this.periods;

            let defaultPeriod = periods.find(period => period.key == process.env.VUE_APP_DEFAULT_PERIOD);

            if (defaultPeriod) {
                return defaultPeriod.key;
            }

            return periods[0].key;
        },
        /**
         * Fire an event with the selected period as payload.
         */
        periodSelected() {
            this.$emit('change', this.period);
        }
    }
};
</script>
